import type { User } from '@/types';

export const usesMomentsScheduling = (coach?: User | null): boolean =>
  coach?.coachProfile?.schedulingProvider === 'moments';
